import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import * as ApexCharts from 'apexcharts';
import { PreincubatorRejectComponent } from '../preincubator-reject/preincubator-reject.component';
import { HistoryDetailsComponent } from '../history-details/history-details.component';
import { ApprovalModalComponent } from '../approval-modal/approval-modal.component';
@Component({
  selector: 'app-application-dashboard',
  templateUrl: './application-dashboard.component.html',
  styleUrls: ['./application-dashboard.component.css'],
})
export class ApplicationDashboardComponent implements OnInit {
  panelOpenState = false;
  private getApi = environment.url + 'preincubation/dashboard?id=';
  private scoreApi = environment.url + environment.calculateScore;
  private ApprovalApi = environment.url + environment.preincubaterapproval;
  dialogRef: any;
  /**
   * Constructor for the ApplicationDashboardComponent.
   * @param getdata The Value service provider.
   * @param makeapi The API service provider.
   * @param notify The Notification service provider.
   * @param dialog The Material dialog service provider.
   */
  constructor(
    private getdata: ValueService,
    private makeapi: ApiService,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {}
  NotImplementColor = '#56c2e6';
  incubaterName;

  /**
   * This method is called when the component is initialized.
   * It fetches the application ID from session storage and calls the getValue() method to fetch the dashboard data.
   * @returns {void}
   */
  ngOnInit(): void {
    this.incubaterName = sessionStorage.getItem('adminIncubName');
    this.getValue();
  }
  dashboardData: any = {};
  role = sessionStorage.getItem('role');
  incubName = sessionStorage.getItem('incubName');
  /**
   * Fetches the dashboard data from the API using the user ID from session storage.
   * Shows a loading indicator during the request, and updates the component's data on success.
   */
  getValue() {
    this.dashboardData = {};
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('userId'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.dashboardData = data;
        // If the user navigates to the dashboard without selecting an application, reload the page.
        let applicationId = sessionStorage.getItem('applicationId');
        if (applicationId == null) {
          window.location.reload();
        }
        // Store the application ID in session storage.
        sessionStorage.setItem('applicationId', data.applicationId);
      });
  }
  timeout: any;
  /**
   * Call the API to generate the scores for the current application.
   * Shows a loader while the API is being called.
   * If the API call is successful, notify the user with a success message
   * and reload the dashboard data.
   * If the API call fails, notify the user with an error message.
   */
  scoreGenerate() {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.scoreApi + sessionStorage.getItem('incubator'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus === 'Success') {
          this.notify.notifysuccess(data.responseMessage);
          this.getValue();
        } else {
          this.notify.notifyError(data.responseMessage);
        }
      });
  }
  /**
   * Render a radial chart with the given value and string.
   * The chart is rendered with a gradient fill and a hollow center.
   * The chart is also rendered with a data label showing the value.
   * @param {number} val The value to be rendered in the chart.
   * @param {string} str The string to be displayed in the chart.
   */
  grap(val: number, str: string) {
    // Create the chart options
    let options = {
      // Set the chart type to radialBar
      chart: {
        height: 350,
        type: 'radialBar',
        // Show the toolbar
        toolbar: {
          show: true,
        },
      },
      // Set the series data
      series: [val],
      // Set the plot options
      plotOptions: {
        radialBar: {
          // Set the start and end angles
          startAngle: 0,
          endAngle: 360,
          // Set the hollow center
          hollow: {
            margin: 0,
            size: '70%',
            background: '#fff',
            image: undefined,
            imageOffsetX: 0,
            imageOffsetY: 0,
            position: 'front',
            // Set the drop shadow
            dropShadow: {
              enabled: true,
              top: 3,
              left: 0,
              blur: 4,
              opacity: 0.24,
            },
          },
          // Set the track
          track: {
            background: '#fff',
            strokeWidth: '67%',
            margin: 0, // margin is in pixels
            // Set the drop shadow
            dropShadow: {
              enabled: true,
              top: -3,
              left: 0,
              blur: 4,
              opacity: 0.35,
            },
          },

          // Set the data labels
          dataLabels: {
            // Show the data labels
            show: true,
            // Set the name
            name: {
              offsetY: -10,
              show: false,
              color: '#888',
              fontSize: '17px',
            },
            // Set the value
            value: {
              // Format the value
              formatter: function (val) {
                return str;
              },
              color: '#111',
              fontSize: '36px',
              show: true,
            },
          },
        },
      },
      // Set the fill
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'dark',
          type: 'horizontal',
          shadeIntensity: 0.5,
          gradientToColors: ['#ABE5A1'],
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100],
        },
      },
      // Set the stroke
      stroke: {
        lineCap: 'round',
      },
      // Set the labels
      labels: [],
    };

    // Render the chart
    let chart = new ApexCharts(document.querySelector('#chart'), options);
    chart.render();
  }
  preIncubatorId = sessionStorage.getItem('userId');
  /**
   * Sends an approval request for the preincubator.
   * If the request is successful, it notifies the user and refreshes the data.
   */
  approval() {
    // Prepare the request payload with the user ID and approval status
    let req = {
      userId: this.preIncubatorId,
      status: 2,
    };

    // Perform the API call to send the approval request
    this.makeapi.method(this.ApprovalApi, req, 'post').subscribe((data) => {
      // Hide the loading indicator after the API call is complete
      this.getdata.amizhthLoader('hide');

      if (data.responseStatus == 'Success') {
        // Notify the user of a successful approval
        this.notify.notifysuccess(data.responseMessage);
        // Refresh the preincubator data
        this.getValue();
      }
    });
  }
  /**
   * Opens a modal dialog for the preincubator to provide clarification.
   * When the dialog is closed, the method refreshes the preincubator details.
   * @param val The id of the preincubator.
   */
  Clarification(val: string) {
    const dialogRef = this.dialog.open(PreincubatorRejectComponent, {
      width: '390px',
      hasBackdrop: false,
      data: { _id: val },
    });
    dialogRef.afterClosed().subscribe((result) => {
      // Show the loader.
      this.getdata.isVisibleSource.next(true);
      // Get the preincubator details.
      this.getValue();
    });
  }
  name;
  animal;
  /**
   * Opens a modal dialog with the history of the preincubator.
   * When the dialog is closed, the method refreshes the preincubator details.
   */
  History() {
    const dialogRef = this.dialog.open(HistoryDetailsComponent, {
      width: '70%',
      height: '40%',
      data: { name: this.name, animal: this.animal },
    });

    dialogRef.afterClosed().subscribe((result) => {
      // Reset the animal variable after the modal is closed.
      this.animal = result;
      // Refresh the preincubator details.
      this.getValue();
    });
  }
  /**
   * Opens a modal dialog for verification of the preincubator details.
   * @param val - The id of the preincubator.
   */
  Verfication(val) {
    const dialogRef = this.dialog.open(ApprovalModalComponent, {
      width: '390px',
      data: { _id: val },
    });

    dialogRef.afterClosed().subscribe((result) => {
      // Hide the loading indicator once the modal is closed.
      this.getdata.isVisibleSource.next(true);
      // Refresh the preincubator details.
      this.getValue();
    });
  }
}
